import Home from "../screens/Home";

const sandbox = "";
export const routes = [
  {
    path: `${sandbox}/certificadoNovo/:hash`,
    component: Home,
    name: "Home",
    menu: false,
  },
  {
    path: '*',
    component: Home,
  }
];
